module.exports = "/_next/static/images/bounty-creator-table-f04d69c12c89c58b7801d985865eb2d6.png";